import type { ComponentProps, ReactElement } from 'react';
import { Toaster as Sonner } from 'sonner';

import { useTheme } from 'src/providers/ThemeProvider';

export const Toaster = ({
  ...props
}: ComponentProps<typeof Sonner>): ReactElement => {
  const { theme } = useTheme();

  return (
    <Sonner
      className='toaster group'
      theme={theme}
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:bg-layout group-[.toaster]:text-layout-foreground group-[.toaster]:border-border-default group-[.toaster]:shadow-lg',
          description: 'group-[.toast]:text-layout-foreground-secondary',
          actionButton:
            'group-[.toast]:bg-primary-default group-[.toast]:text-primary-foreground',
          cancelButton:
            'group-[.toast]:bg-secondary-default group-[.toast]:text-secondary-foreground',
        },
      }}
      {...props}
    />
  );
};
